import React from "react";
import { useSelector } from "react-redux";
import { Dimmer, Image, Loader, Placeholder, Segment } from "semantic-ui-react";

const LoaderGameList = ({
  children,
  commonLoading,
  className,
  imageRows = 1,
}) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);

  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  //   const loadingStatus = true;

  return (
    <React.Fragment>
      {loadingStatus || commonLoading ? (
        <Segment
          className={`!border-0 !shadow-none dark:!bg-base-dark !bg-base-white !min-h-[180px] !my-[5px] !p-[5px]`}
        >
          <Placeholder
            inverted={isDarkMode}
            className={`${className} w-full !rounded-[15px]`}
            style={{ animationPlayState: "paused" }}
          >
            <Placeholder.Image />
          </Placeholder>
          <Placeholder
            inverted={isDarkMode}
            className="!mt-[12px] !w-[50px] h-[7px] flex items-end rounded-full"
            style={{ animationPlayState: "paused" }}
          >
            <Placeholder.Image />
          </Placeholder>
          <Placeholder
            inverted={isDarkMode}
            className="!mt-[12px] !w-[100px] h-[7px] flex items-end rounded-full"
            style={{ animationPlayState: "paused" }}
          >
            <Placeholder.Image />
          </Placeholder>
        </Segment>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}{" "}
    </React.Fragment>
  );
};

export default LoaderGameList;
